export default [{
  '_index': 'dev-inss-omniv2_interactions',
  '_type': '_doc',
  '_id': '9740f0e4-c065-4483-b33c-cde854aeafc5',
  '_score': 5.356126,
  '_source': {
    'conversation_id': '07c5a19b-d614-4377-b0f6-0eb4bd31f1cf',
    'sender_name': 'Helô',
    'sender_type': 'machine',
    'sender_component': 'omniV2Conversation::saveMachineInteraction',
    'event_text': 'Ok. De qual documento você precisa? É só escolher um dos botões abaixo.',
    'input_text': 'Extratos, Certidões e Declarações',
    'event_received': true,
    'event_type': 'message',
    'event_object': {
      'buttons': [
        {
          'title': 'Extrato de Contribuições (CNIS)',
          'payload': 'Extrato de Contribuições (CNIS)',
          'content_type': 'text'
        },
        {
          'title': 'Extrato de Empréstimo Consignado',
          'payload': 'Extrato de Empréstimo Consignado',
          'content_type': 'text'
        },
        {
          'title': 'Extrato de Pagamento de Benefícios',
          'payload': 'Extrato de Pagamento de Benefícios',
          'content_type': 'text'
        },
        {
          'title': 'Declaração de Beneficiário do INSS',
          'payload': 'Declaração de Beneficiário do INSS',
          'content_type': 'text'
        },
        {
          'title': 'Certidão de Tempo de Contribuição (CTC)',
          'payload': 'Certidão de Tempo de Contribuição (CTC)',
          'content_type': 'text'
        },
        {
          'title': 'Certidão de Inexistência de Dependentes Habilitados à Pensão por Morte',
          'payload': 'Certidão de Inexistência de Dependentes Habilitados à Pensão por Morte',
          'content_type': 'text'
        },
        {
          'title': 'Extrato de Imposto de Renda',
          'payload': 'Extrato de Imposto de Renda',
          'content_type': 'text'
        },
        {
          'title': 'Declaração de Contribuinte Individual (DRSCI)',
          'payload': 'Declaração de Contribuinte Individual (DRSCI)',
          'content_type': 'text'
        },
        {
          'title': 'Carta de Concessão',
          'payload': 'Carta de Concessão',
          'content_type': 'text'
        },
        {
          'title': 'Voltar ao Menu',
          'payload': 'Voltar ao Menu',
          'content_type': 'text'
        }
      ]
    },
    'timezone': 'America/Sao_Paulo',
    'request_datetime': '2021-09-28T16:43:50.800Z',
    'input_datetime': '2021-09-28T16:37:52.689Z',
    'output_datetime': '2021-09-28T16:43:50.802Z',
    'response_time': 358113,
    'process_time': '2021-09-28T16:43:50.871Z'
  },
  'highlight': {
    'event_text': [
      "Ok. De qual <span class='highlight'>documento</span> você precisa? É só escolher um dos botões abaixo."
    ]
  }
},
{
  '_index': 'dev-inss-omniv2_interactions',
  '_type': '_doc',
  '_id': '2dffda59-7fa2-4f91-8582-e4ff9462b33a',
  '_score': 5.356126,
  '_source': {
    'conversation_id': '7d8c1b67-0629-4b12-8ff6-4df89239b7fc',
    'sender_name': 'Helô',
    'sender_type': 'machine',
    'sender_component': 'omniV2Conversation::saveMachineInteraction',
    'event_text': 'Ok. De qual documento você precisa? É só escolher um dos botões abaixo.',
    'input_text': 'Extratos, Certidões e Declarações',
    'event_received': true,
    'event_type': 'message',
    'event_object': {
      'buttons': [
        {
          'title': 'Extrato de Contribuições (CNIS)',
          'payload': 'Extrato de Contribuições (CNIS)',
          'content_type': 'text'
        },
        {
          'title': 'Extrato de Empréstimo Consignado',
          'payload': 'Extrato de Empréstimo Consignado',
          'content_type': 'text'
        },
        {
          'title': 'Extrato de Pagamento de Benefícios',
          'payload': 'Extrato de Pagamento de Benefícios',
          'content_type': 'text'
        },
        {
          'title': 'Declaração de Beneficiário do INSS',
          'payload': 'Declaração de Beneficiário do INSS',
          'content_type': 'text'
        },
        {
          'title': 'Certidão de Tempo de Contribuição (CTC)',
          'payload': 'Certidão de Tempo de Contribuição (CTC)',
          'content_type': 'text'
        },
        {
          'title': 'Certidão de Inexistência de Dependentes Habilitados à Pensão por Morte',
          'payload': 'Certidão de Inexistência de Dependentes Habilitados à Pensão por Morte',
          'content_type': 'text'
        },
        {
          'title': 'Extrato de Imposto de Renda',
          'payload': 'Extrato de Imposto de Renda',
          'content_type': 'text'
        },
        {
          'title': 'Declaração de Contribuinte Individual (DRSCI)',
          'payload': 'Declaração de Contribuinte Individual (DRSCI)',
          'content_type': 'text'
        },
        {
          'title': 'Carta de Concessão',
          'payload': 'Carta de Concessão',
          'content_type': 'text'
        },
        {
          'title': 'Voltar ao Menu',
          'payload': 'Voltar ao Menu',
          'content_type': 'text'
        }
      ]
    },
    'timezone': 'America/Sao_Paulo',
    'request_datetime': '2021-09-30T21:02:48.554Z',
    'input_datetime': '2021-09-30T21:02:48.120Z',
    'output_datetime': '2021-09-30T21:02:48.559Z',
    'response_time': 439,
    'reply': 'Helô',
    'user_channel': 'webclient',
    'process_time': '2021-09-30T21:02:48.590Z'
  },
  'highlight': {
    'event_text': [
      "Ok. De qual <span class='highlight'>documento</span> você precisa? É só escolher um dos botões abaixo."
    ]
  }
},
{
  '_index': 'dev-inss-omniv2_interactions',
  '_type': '_doc',
  '_id': '0992e7b9-a042-4b52-b12d-9ff52e6ed928',
  '_score': 1.9869852,
  '_source': {
    'conversation_id': '7d8c1b67-0629-4b12-8ff6-4df89239b7fc',
    'sender_name': 'Helô',
    'sender_type': 'machine',
    'sender_component': 'omniV2Conversation::saveMachineInteraction',
    'event_text': `Um procurador pode realizar a Prova de Vida por você. Isso é possível se você:<br><br>
    <ul>
    <li>Estiver ausente do país por motivo de viagem;</li>
    <li>For portador(a) de doença contagiosa;</li>
    <li>Tiver dificuldades de locomoção;</li>
    <li>Tiver 80 anos ou mais.</li>
    </ul><br><br>
    <b>Importante!</b> É preciso que este procurador esteja cadastrado no INSS.<br><br>
    
    Quando for realizar a prova de vida no banco, o procurador deve levar um documento de identificação válido com foto.<br><br>
    
    Conseguiu encontrar o que procurava?`,
    'input_text': 'Por Procuração',
    'event_received': true,
    'event_type': 'message',
    'event_object': {
      'buttons': [
        {
          'title': 'Sim',
          'payload': 'Sim',
          'content_type': 'text'
        },
        {
          'title': 'Não',
          'payload': 'Não',
          'content_type': 'text'
        },
        {
          'title': 'Voltar ao Menu',
          'payload': 'Voltar ao Menu',
          'content_type': 'text'
        }
      ]
    },
    'timezone': 'America/Sao_Paulo',
    'request_datetime': '2021-09-30T21:01:14.565Z',
    'input_datetime': '2021-09-30T21:01:13.768Z',
    'output_datetime': '2021-09-30T21:01:14.568Z',
    'response_time': 800,
    'reply': 'Helô',
    'user_channel': 'webclient',
    'process_time': '2021-09-30T21:01:14.599Z'
  },
  'highlight': {
    'event_text': [
      `vida no banco, o procurador deve levar um <span class='highlight'>documento</span> de identificação válido com foto.<br><br>
      Conseguiu encontrar o que procurava?`
    ]
  }
},
{
  '_index': 'dev-inss-omniv2_interactions',
  '_type': '_doc',
  '_id': '282b1002-489c-4395-a195-d40cec2c1753',
  '_score': 1.6540451,
  '_source': {
    'conversation_id': '7d8c1b67-0629-4b12-8ff6-4df89239b7fc',
    'sender_name': 'Helô',
    'sender_type': 'machine',
    'sender_component': 'omniV2Conversation::saveMachineInteraction',
    'event_text': `É o documento que permite ao servidor público que contribuiu para o Regime Geral de Previdência Social levar o tempo de contribuição no INSS para o Regime Próprio de Previdência Social do órgão onde ele trabalha atualmente.<br><br>

    Este serviço é destinado ao servidor que ainda não possui Certidão de Tempo Contribuição emitida pelo INSS. Caso já possua a certidão e deseje incluir/alterar/excluir algum período, solicite o serviço de “Revisão de Certidão de Tempo de Contribuição”.<br><br>
    
    Se você já possui a certidão concedida pelo INSS, é possível imprimir a via original ou emitir uma segunda via pelo Meu INSS.<br><br>
    
    Escolha a opção desejada nos botões abaixo.`,
    'input_text': 'Certidão de Tempo de Contribuição (CTC)',
    'event_received': true,
    'event_type': 'message',
    'event_object': {
      'buttons': [
        {
          'title': 'Pedir uma CTC',
          'payload': 'Pedir uma CTC',
          'content_type': 'text'
        },
        {
          'title': 'Já tenho uma CTC e quero emitir ou reemitir o documento',
          'payload': 'Já tenho uma CTC e quero emitir ou reemitir o documento',
          'content_type': 'text'
        },
        {
          'title': 'Quero pedir revisão da minha CTC',
          'payload': 'Quero pedir revisão da minha CTC',
          'content_type': 'text'
        },
        {
          'title': 'Quero cancelar a minha CTC',
          'payload': 'Quero cancelar a minha CTC',
          'content_type': 'text'
        },
        {
          'title': 'Voltar ao Menu',
          'payload': 'Voltar ao Menu',
          'content_type': 'text'
        }
      ]
    },
    'timezone': 'America/Sao_Paulo',
    'request_datetime': '2021-09-30T21:02:52.211Z',
    'input_datetime': '2021-09-30T21:02:51.683Z',
    'output_datetime': '2021-09-30T21:02:52.216Z',
    'response_time': 533,
    'reply': 'Helô',
    'user_channel': 'webclient',
    'process_time': '2021-09-30T21:02:52.255Z'
  },
  'highlight': {
    'event_text': [
      "É o <span class='highlight'>documento</span> que permite ao servidor público que contribuiu para o Regime Geral de Previdência"
    ]
  }
}]
